import { VisuallyHidden } from '@n26/nxd'
import type { TrendDirection } from '@/features/dashboard/api/schemas'
import { formatChange } from '@/features/dashboard/format/format'
import { Odometer, zeroFrom } from '../charts/Odometer'
import styles from './DeltaBadge.module.css'

// Triangle glyphs from bristol's cockpit (`TRIANGLE_UP_D` / `TRIANGLE_DOWN_D`).
const TRIANGLE_UP =
  'M17.8892 15.7522C18.2722 16.4188 17.7909 17.2503 17.0221 17.2503H6.97756C6.20872 17.2503 5.72748 16.4188 6.11045 15.7522L11.1327 7.00969C11.5171 6.34052 12.4825 6.34052 12.8669 7.00969L17.8892 15.7522Z'
const TRIANGLE_DOWN =
  'M17.8892 8.24812C18.2722 7.58146 17.7909 6.75 17.0221 6.75H6.97756C6.20872 6.75 5.72748 7.58146 6.11045 8.24813L11.1327 16.9906C11.5171 17.6598 12.4825 17.6598 12.8669 16.9906L17.8892 8.24812Z'

type DeltaBadgeProps = {
  /** Fractional change, e.g. 0.059 for +5.9%. */
  fraction: number
  direction: TrendDirection
  /** small: a tile's 16px variation; large: the expanded card's 20px one. */
  size?: 'small' | 'large'
}

// The change rolls up from zero, as bristol's does.
export const DeltaBadge = ({
  fraction,
  direction,
  size = 'small',
}: DeltaBadgeProps) => {
  const change = formatChange(fraction).replace(/^[+−]/, '')
  return (
    <span className={`${styles.badge} ${styles[size]} ${styles[direction]}`}>
      {direction !== 'flat' && (
        <svg viewBox='0 0 24 24' width='24' height='24' aria-hidden='true'>
          <path
            fill='currentColor'
            d={direction === 'up' ? TRIANGLE_UP : TRIANGLE_DOWN}
          />
        </svg>
      )}
      {direction !== 'flat' && (
        <VisuallyHidden>{direction === 'up' ? 'Up' : 'Down'}</VisuallyHidden>
      )}
      <VisuallyHidden>{change}</VisuallyHidden>
      <Odometer
        value={change}
        from={zeroFrom(change)}
        direction={direction === 'down' ? 'down' : 'up'}
      />
    </span>
  )
}
